<c-sidebar
  #sidebar="cSidebar"
  id="sidebar"
  [unfoldable]="false"
  [visible]="sidebarVisible"
  (visibleChange)="sidebarVisible = $event"
  style="background-color: #0d0d0d"
  [narrow]="sidebarCollapsed"
>
  <ng-scrollbar pointerEventsMethod="scrollbar">
    <c-sidebar-nav>
      <div class="mobile-sidebar-header" *ngIf="isMobile">
        <button class="mobile-back-box" (click)="sidebarVisible = false">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.2475 4.5C20.8678 4.5 20.5541 4.78227 20.5045 5.14836L20.4976 5.25014L20.5 18.2542C20.5001 18.6684 20.8359 19.0041 21.2501 19.0041C21.6298 19.0041 21.9436 18.7218 21.9932 18.3557L22 18.2539L21.9976 5.24986C21.9976 4.83565 21.6617 4.5 21.2475 4.5ZM8.3529 6.30373L8.28028 6.21961C8.01398 5.95338 7.59731 5.92921 7.30373 6.1471L7.21962 6.21972L2.223 11.2174C1.95691 11.4835 1.93261 11.8999 2.15017 12.1935L2.22269 12.2776L7.21931 17.2811C7.512 17.5742 7.98687 17.5745 8.27997 17.2818C8.54642 17.0157 8.57091 16.5991 8.35325 16.3053L8.28069 16.2211L4.57 12.504L18.247 12.5049C18.6267 12.5049 18.9405 12.2228 18.9902 11.8567L18.997 11.7549C18.997 11.3752 18.7149 11.0615 18.3488 11.0118L18.247 11.0049L4.557 11.004L8.28039 7.28028C8.54662 7.01398 8.57079 6.59732 8.3529 6.30373L8.28028 6.21961L8.3529 6.30373Z"
              fill="#ffffff"
            />
          </svg>
        </button>
      </div>

      <div
        class="sidebar-content"
        [ngClass]="{
          collapsed: sidebarCollapsed || !sidebarVisible,
        }"
      >
        <div *ngFor="let item of navItems">
          <div
            *ngIf="!item.children"
            class="nav-item"
            [ngClass]="{ active: item.name === activeParent }"
            (click)="toggleParent(item); navigateTo(item.url)"
            [attr.data-label]="item.name"
            (mouseenter)="sidebarCollapsed && showTooltip($event, item.name)"
            (mouseleave)="sidebarCollapsed && hideTooltip()"
          >
            <img src="{{ item.icon }}" (error)="onImageError($event)" />
            <span>{{ item.name }}</span>
            <span *ngIf="item?.badge" class="count-badge">
              <div>
                {{ item?.badge?.text || "0" }}
              </div>
            </span>
          </div>

          <div
            *ngIf="item.children"
            (click)="toggleDropdown(item);hideTooltip()"
            [attr.data-label]="item.name"
            (mouseenter)="sidebarCollapsed && showTooltip($event, item.name)"
            (mouseleave)="sidebarCollapsed && hideTooltip()"
          >
            <div class="nav-item" [ngClass]="{ active: item.expanded }">
              <img src="{{ item.icon }}" (error)="onImageError($event)" />
              <span>{{ item.name }}</span>
            </div>
            <div *ngIf="item.expanded">
              <div
                *ngFor="let child of item.children"
                class="nav-item sub-item"
                style="margin-top: 10px"
                [ngClass]="{ active: child.name === activeChild }"
                (click)="
                  toggleParentChild(child.name);
                  navigateTo(child.url);
                  $event.stopPropagation()
                "
              >
                <img src="assets/images/Vector.svg" />
                <span>{{ child.name }}</span>
                <span *ngIf="child?.badge" class="count-badge">
                  <div>
                    {{ child?.badge?.text || "0" }}
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </c-sidebar-nav>
  </ng-scrollbar>
</c-sidebar>
<div class="global-tooltip" *ngIf="tooltipVisible" [style.top.px]="tooltipY">
  {{ hoverLabel }}
</div>
<app-loader></app-loader>
<div
  class="wrapper-layout"
  [ngClass]="{
    'desktop-open': !isMobile && sidebarVisible && !sidebarCollapsed,
    'desktop-collapsed': !isMobile && sidebarVisible && sidebarCollapsed,
    mobile: isMobile,
  }"
>
  <app-header
    *ngIf="!isWebView"
    class="d-print-none header header-sticky"
    [sidebarCollapsed]="sidebarCollapsed"
    (toggleSidebarEvent)="toggleSidebar()"
  >
  </app-header>

  <div class="body flex-grow-1 px-3" style="background-color: #f8f8f8">
    <router-outlet></router-outlet>
  </div>
</div>
